import React from 'react';
import colors from 'shared-components/theme/colors';
import { gilroyMedium } from 'shared-components/theme/fonts';
import Media from 'shared-components/theme/medias';
import styled from 'styled-components';
const IntroductionTitle = ({ title, textColor }) => {
    return (
        <IntoTitle
            textColor={textColor}
            dangerouslySetInnerHTML={{ __html: title }}></IntoTitle>
    );
};

export default IntroductionTitle;

const IntoTitle = styled.h2`
    font-size: 38px;
    color: ${(props) => props.textColor || colors.geoWhite[100]};
    font-family: ${gilroyMedium};
    font-weight: 500;
    ${Media('large')} {
        font-size: 2.261vw;
    }
    @media (max-width: 1024px) {
        font-size: 28px;
    }
`;
